export const convertStepCollectionToSchema = steps => steps?.resources()
  .list()
  .map(step => ({
    label: step.attr('stepName'),
    isComplete: step.attr('completed') === 'true',
  }));
